var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2024-08-20
 * @brief SEI 에너지솔루션 관리 -고효율 설비 List 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import EhpPagination from "@components/common/pagination/EhpPagination";
import { alertState } from "@recoil/assessmentState";
import { langId } from "@recoil/langState";
import { loadingBoxState } from "@recoil/menuState";
import { userInfoLoginState } from "@recoil/userState";
import * as HTTPUTIL from "@utils/api/HttpUtil";
import * as CUTIL from "@utils/commUtils";
import * as CONST from "@utils/Const";
import { useText } from "@utils/langs/useTrans";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
//압축 다운로드
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default function HighEfficiencyFacilityList(props) {
    // Trans
    const t = useText();
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    //props
    const {} = props;
    //
    const [spgItem, setSpgItem] = useState([]);
    const [groupName, setGroupName] = useState(null);
    const [subSpgItem, setSubSgpItem] = useState([]);
    const [subGroup, setSubGroup] = useState(null);
    const defaultPageInfo = { size: 10, totalElements: 0, totalPages: 0, number: 0, psize: 10, listReload: false };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
        HightManagementList(subGroup.spgId, page);
    }
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    const [eleicnfoThItem, setElecInfoThItem] = useState([]);
    const [hightItem, setHightItem] = useState([]);
    const [hightDetail, setHightDetail] = useState(null);
    // List API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/spgs/equipchange`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds,
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSpgItem(data.body);
                setGroupName(data.body[0].groupName);
                setSubSgpItem(data.body[0].subGroup);
                if (data.body[0].subGroup.length > 0) {
                    setSubGroup(data.body[0].subGroup[0]);
                    HightManagementList(data.body[0].subGroup[0].spgId, 0);
                }
                setSortData({
                    sortField: "",
                    sort: "asc",
                });
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    }, [data, langIds]);
    // spg 선택
    const spgSelect = (item) => {
        setGroupName(item.groupName);
        setSubSgpItem(item.subGroup);
        setSubGroup(item.subGroup[0]);
        HightManagementList(item.subGroup[0].spgId, 0);
        setSortData({
            sortField: "",
            sort: "asc",
        });
    };
    // subSpg 선택
    const subSpgSelect = (item) => {
        setSubGroup(item);
        setSortData({
            sortField: "",
            sort: "asc",
        });
        HightManagementList(item.spgId, 0);
    };
    useEffect(() => {
        if (subGroup && sortData.sortField.length > 0) {
            HightManagementList(subGroup.spgId, 0);
        }
    }, [sortData]);
    const HightManagementList = (spgId, number) => __awaiter(this, void 0, void 0, function* () {
        setRecoilIsLoadingBox(true);
        let appPath = `spgId=${spgId}`;
        appPath = appPath + `&page=${number}&size=${pageInfo.size}`;
        // 정렬 적용된 주소
        if (sortData.sortField) {
            appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
        }
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/energyreport/highlyefficientequipment?${appPath}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setHightItem(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: data.data.page.totalElements })); //5, 10; // psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false,
                setElecInfoThItem(data.body.length > 0
                    ? data.body[0].elecInfos
                        .filter((_, idx) => idx < 2)
                        .map((item, idx) => (Object.assign(Object.assign({}, item), { thCode: "elecInfo0" + (idx + 1) })))
                    : []);
                setHightDetail(data.body[0]);
                setRecoilIsLoadingBox(false);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : CONST.ERROR_MSG, callBack: () => {
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                setRecoilIsLoadingBox(false);
            }
        }
    });
    // 정렬 버튼 액션
    const onClickSort = (sort) => {
        // list 수정
        // handleCurPage(0)
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    };
    // list 클릭
    const ListChange = (item) => {
        setHightDetail(item);
    };
    // 엑셀 리스트 API
    const ListExcell = (e) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        let appPath = `spgId=${subGroup.spgId}`;
        appPath = appPath + `&page=${0}&size=${pageInfo.totalElements}`;
        // 정렬 적용된 주소
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/energyreport/highlyefficientequipment?${appPath}`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                excelDownloadSaved(data.body);
            }
        }
    });
    // List Download
    const excelDownloadSaved = (excelData) => {
        // spg naem, 영문 name
        const uniqueSpgName = new Set();
        const uniqueSpgNameEn = new Set();
        // elecInfo 정보만 추출
        const result = [];
        excelData.forEach((item) => {
            if (!uniqueSpgName.has(item.spgName)) {
                uniqueSpgName.add(item.spgName);
                uniqueSpgNameEn.add(item.spgNameEn);
            }
            item.elecInfos.forEach((info) => {
                result.push(info);
            });
        });
        // elecInfo 의 code, name(unit)
        const uniqueCodes = new Set();
        const uniqueName = new Set();
        result.filter((item) => {
            if (!uniqueCodes.has(item.code)) {
                uniqueCodes.add(item.code);
                uniqueName.add(`${item.name}(${item.unit})`);
                return true;
            }
            return false;
        });
        const execHeaderList = ["설비유형", "설비유형(영문)", "형명", "형명(영문)", "제조사", "제조사(영문)"];
        const exclHeader = [...execHeaderList, ...uniqueCodes];
        const exclDescription = [...uniqueSpgName, ...uniqueSpgNameEn, "O", "O", "O", "O", ...uniqueName];
        //
        const excelFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"; // 파일 타입 및 유니코드
        const excelFileExtension = ".xlsx"; // 확장자 명
        const excelFileName = `${groupName}_${subGroup.name}`; // 파일명
        const excelSheet = XLSX.utils.aoa_to_sheet([exclHeader, exclDescription]);
        // 헤더 병합을 위해 셀 주소를 설정
        excelSheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
            { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } },
            { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } },
            { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } },
            { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } },
            { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // 여섯 번째 헤더 병합
        ];
        excelData.map((sheet, idx) => {
            const row = [
                sheet.spgName,
                sheet.spgNameEn,
                sheet.itemName,
                sheet.itemNameEn,
                sheet.manufacturer,
                sheet.manufacturerEn, // 제조사 En
            ];
            // 각 code에 맞는 value를 추가
            uniqueCodes.forEach((code) => {
                const info = sheet.elecInfos.find((info) => info.code === code);
                row.push(info ? info.value : ""); // 해당 code가 없으면 빈 문자열 추가
            });
            XLSX.utils.sheet_add_aoa(excelSheet, [row], { origin: -1 });
            excelSheet["!cols"] = [
                //< --행 사이즈
                { width: 15 },
                { width: 25 },
                { width: 50 },
                { width: 50 },
                { width: 15 },
                { width: 20 }, // 제조사 En
            ];
            return false;
        });
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
    };
    // 엑셀 업로드 input
    const ExcelInput = (e) => {
        let input = document.createElement("input");
        input.type = "file";
        input.accept = ".xls,.xlsx";
        input.onchange = (e) => {
            var _a;
            const selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
            ExleUPload(selectedFile);
        };
        input.click();
    };
    // 업로드 API
    const ExleUPload = (files) => __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append("file", files);
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "POSTF",
            appPath: `/energyreport/highlyefficientequipment?spgId=${subGroup.spgId}`,
            appQuery: formData,
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setAlerts(Object.assign(Object.assign({}, alerts), { layerId: "false", divTag: data.errorList !== null ? data.body : data.solution, callBack: () => {
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        setSortData({
                            sortField: "",
                            sort: "asc",
                        });
                        HightManagementList(subGroup.spgId, 0);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                setAlerts(Object.assign(Object.assign({}, alerts), { layerId: "false", type: CONST.TYPE_NONE, divTag: data.errorList !== null ? data.errorList.map((err) => err.msg) : data.solution, callBack: () => {
                        CUTIL.jsclose_Popup(CONST.POP_ALERT);
                    } }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
        }
    });
    return (_jsxs(_Fragment, { children: [_jsxs("article", Object.assign({ className: "flex-7" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-24" }, { children: [_jsxs("div", Object.assign({ className: "select spg", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: groupName ? groupName : "전체" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: spgItem &&
                                                spgItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => spgSelect(list) }, { children: list.groupName }), "spgList_" + idx.toString()))) })] })), _jsxs("div", Object.assign({ className: "select subSpg", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: subGroup ? subGroup.name : "전체" })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: subSpgItem &&
                                                subSpgItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => subSpgSelect(list) }, { children: list.name }), "subSpgList_" + idx.toString()))) })] }))] })) })), _jsxs("div", Object.assign({ className: `box__body pt-0 ${eleicnfoThItem.length <= 0 ? "nodata" : ""}` }, { children: [_jsx("div", Object.assign({ className: "tbl__top mt-46" }, { children: _jsxs("div", Object.assign({ className: "right" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => ListExcell(e) }, { children: _jsx("span", { children: "\uACE0\uD6A8\uC728 \uC124\uBE44 List \uB2E4\uC6B4\uB85C\uB4DC" }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => ExcelInput(e) }, { children: _jsx("span", { children: "Excel \uC5C5\uB85C\uB4DC" }) }))] })) })), _jsxs("div", Object.assign({ className: "tbl-list tbl-select line-1 hcal-70" }, { children: [_jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." })), _jsxs("table", Object.assign({ summary: "No, \uC124\uBE44 \uC0C1\uC138 \uC720\uD615, \uD615\uBA85, LS\uC77C\uB809\uD2B8\uB9AD, \uC815\uACA9 \uC804\uC555, \uC804\uB958 \uC804\uC555 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uACE0\uD6A8\uC728 \uC124\uBE44 List \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uACE0\uD6A8\uC728 \uC124\uBE44 List" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "25%" } }), _jsx("col", { style: { width: "25%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: "No" })), _jsx("th", Object.assign({ scope: "col", className: "txt-left" }, { children: _jsx("span", { children: "\uC124\uBE44 \uC0C1\uC138 \uC720\uD615" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "itemName" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort("itemName") }, { children: _jsx("span", { children: "\uD615\uBA85" }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "manufacturer" && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort("manufacturer") }, { children: _jsx("span", { children: "\uC81C\uC870\uC0AC" }) })), eleicnfoThItem &&
                                                            eleicnfoThItem.map((list, idx) => (_jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === list.thCode && sortData.sort === "desc" ? "desc" : "asc"}`, onClick: (e) => onClickSort(list.thCode) }, { children: _jsxs("span", { children: [list.name, list.type < 2 ? `(${list.unit})` : ""] }) }), "elecInfoThList_" + idx.toString())))] }) }), _jsx("tbody", { children: hightItem &&
                                                    hightItem.map((list, idx) => (_jsxs("tr", Object.assign({ className: list == hightDetail ? "selected" : "", onClick: (e) => ListChange(list) }, { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.spgName ? list.spgName : "-" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemName ? list.itemName : "-" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.manufacturer ? list.manufacturer : "-" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.elecInfo01 })) }), list.elecInfo02 && (_jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.elecInfo02 })) }))] }), "higtList_" + idx.toString()))) })] }))] })), _jsx(EhpPagination, { componentName: "HIGHTMANAGEMENTLIST", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })), _jsx("article", Object.assign({ className: "flex-3" }, { children: _jsxs("div", Object.assign({ className: `box__body p-40 ${!hightDetail ? "nodata" : ""}` }, { children: [_jsx("h3", { children: "\uC124\uBE44 \uC815\uBCF4" }), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uB370\uC774\uD130\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4." })), hightDetail && (_jsxs("ul", Object.assign({ className: "form__input mt-24" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC124\uBE44 \uC720\uD615" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp221", value: hightDetail.spgName ? hightDetail.spgName : "-", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uD615 \uBA85" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp222", value: hightDetail.itemName ? hightDetail.itemName : "-", readOnly: true }) }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uC81C\uC870\uC0AC" })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp232", value: hightDetail.manufacturer ? hightDetail.manufacturer : "-", readOnly: true }) }))] }), hightDetail.elecInfos.map((list, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit star mt-0" }, { children: [list.name, list.type < 2 ? `(${list.unit})` : "", _jsx("br", {}), _jsxs("span", Object.assign({ className: "fontRegular" }, { children: ["(", list.code, ")"] }))] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "inp233" + idx, value: list.value ? list.value : "-", readOnly: true }) }))] }, "elecInfos_excl" + idx.toString())))] })))] })) }))] }));
}
